import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/tvsmart.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Every TV will now be SMART!"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle-1 mt-n1" }, "Watch premium OTT")
], -1)
const _hoisted_2 = { class: "mt-3 d-flex justify-center image-holder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, { src: _imports_0 }),
      _createVNode(_component_router_link, { to: "/tv" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, { class: "btn-primary on-image getnow" }, {
            default: _withCtx(() => [
              _createTextVNode("Get Now")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}